<template>
  <div class="w-full mb-4">
      <div class="" v-if="fileRecords.length > 0">
        <vs-tooltip class="inline-block" :text="theme != 'list' ? 'List' : 'Grid'" color="primary" position="top">
          <vs-button 
          class="includeIcon includeIconOnly mb-2"
          color="primary" type="filled"
          @click.prevent="switchTheme">
              <span v-if="theme != 'list'" class="material-icons-outlined">format_list_bulleted</span>
              <!-- <span v-if="theme != 'list'">List View</span> -->
              <span v-if="theme == 'list'" class="material-icons-outlined">grid_view</span>
              <!-- <span v-if="theme == 'list'">Grid View</span> -->
            </vs-button>
        </vs-tooltip>
      </div>
    <div class="cstm_vuefileagent_holder">  
      <span>Attached Files</span>
      <!-- {{lesson_file_index}} -->
      <VueFileAgent
        ref="vueFileAgent"
        :theme="theme"
        :meta="true"   
        v-model="fileRecords"
        :readonly="true"
        :linkable="true"
        :deletable="deleteOption"
        @beforedelete="openConfirm($event)"
        @delete="fileDeleted($event)"
      ></VueFileAgent>
    </div>

    <!-- <pre>{{fileRecordsForUpload}}</pre>
    <pre>{{fileRecords}}</pre>
    <pre>{{filesInfo}}</pre> -->
  </div>
</template>

<script>
export default {
  props:{
    filesInfo:{
      default:() => []

    },
    singleFileInfo:{
      default:() => {}

    },
    file_ids:{
      default:() => []
    },
    deleteOption:{
      default:true
    }
  },
  created () {
    if (this.filesInfo.length) {
      this.fileRecords = this.filesInfo.map((ele) => {
        return {
          'file_id':ele.file.id,
          'name':ele.file.file_name,
          'sizeText':this.bytesToSize(ele.file.size),
          'size':ele.file.size,
          'type':ele.file.file_type,
          'url':ele.file.file_path

        }
      })
      
    }

    //for single file
    
    if (this.singleFileInfo) {
      const checkingSingleObject = this.singleFileInfo.hasOwnProperty('file_name')
      
      if (checkingSingleObject) {
        this.fileRecords[0] = {
          'name':this.singleFileInfo.file_name,
          'sizeText':this.bytesToSize(this.singleFileInfo.size),
          'size':this.singleFileInfo.size,
          'type':this.singleFileInfo.file_type,
          'url':this.singleFileInfo.file_path
        }
      }
      
    }
    // 
  },
  data () {
    return {
      fileRecords:[],
      theme:'grid',
      auto: true,
      uploadUrl: '',
      ///file/upload/${platform_customer_id}
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent', 'Authorization': '' },
      fileRecordsForUpload: [] // maintain an upload queue
    }
  },

  methods: {
    bytesToSize (bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
    },
    getExtensionName (filename) {
      return filename.split('.').pop()

    },
    switchTheme () {
      this.theme = this.theme === 'list' ? 'default' : 'list'
    },
    uploadEvent (eventName, data) {
      
    },
   
    filesSelected (fileRecordsNewlySelected) {
      
       
      const validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error) 
           
      
      if (this.section_type === 'courseHeader') {
        this.fileRecordsForUpload = fileRecordsNewlySelected
        if (!validFileRecords.length) {
          this.fileRecordsForUpload.length = 0

        } 


      } else {
        this.imagevalidation = ''

        this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords)
       

      }
    },

    openConfirm (fileRecord) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete this file?',
        accept: this.acceptAlert,
        parameters: fileRecord
      })
    
    },
    acceptAlert (fileRecord) {        
      this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event     
    },
    fileDeleted (fileRecord) {
      const file_id = fileRecord.file_id
      
      const index = this.file_ids.indexOf(file_id) // 1

      this.file_ids.splice(index, 1)

      
    }

    // deleteUploadedFile (fileRecord) {
    //   const i = this.fileRecordsForUpload.indexOf(fileRecord)

    //   
    //   
    //   this.file_ids.splice(i, 1)
    //   // Using the default uploader. You may use another uploader instead.
    //   // this.$refs.vueFileAgent.deleteUpload(
    //   //   this.uploadUrl,
    //   //   this.uploadHeaders,
    //   //   fileRecord
    //   // )
    // }
  }
}
</script>